@if (customRouteData()) {
  <app-box-1 
    [padding]="32"
    [borderWidth]="2"
    [borderRadius]="32"
    [backgroundColor]="'#00000060'"
    [backdropFilterBlur]="24"
  >
    <div class="custom-route__container">
      <app-points />
      
      <app-map 
        [style.view-transition-name]="'route-map'"
      />
    </div>
  </app-box-1>
}


